__turbopack_context__.v({
  "card": "WbgYBa_card",
  "cardBody": "WbgYBa_cardBody",
  "cardCopy": "WbgYBa_cardCopy",
  "cardSubtitle": "WbgYBa_cardSubtitle",
  "cardTitle": "WbgYBa_cardTitle",
  "cardTop": "WbgYBa_cardTop",
  "imageSlot": "WbgYBa_imageSlot",
  "reasonsList": "WbgYBa_reasonsList",
  "reasonsSection": "WbgYBa_reasonsSection",
  "stickyItem": "WbgYBa_stickyItem",
});
